/* tslint:disable */
export * from './Email';
export * from './FileStorage';
export * from './Storage';
export * from './StorageAttendance';
export * from './StorageAttendanceLocal';
export * from './StorageChat';
export * from './StorageClaim';
export * from './StorageCompanyProfile';
export * from './StorageProfile';
export * from './StoragePost';
export * from './Stsmartnoticecomments';
export * from './Stsmartnoticemember';
export * from './Tsaimaster';
export * from './Register';
export * from './RegisterOnboarding';
export * from './SFAttendance';
export * from './SFLeaveRequest';
export * from './SFOvertimeRequest';
export * from './Sunfish';
export * from './Tclmuser';
export * from './Tcltrequest';
export * from './Teodempaddress';
export * from './Teodempcompany';
export * from './Teodemppersonal';
export * from './Teodempsurvey';
export * from './Teodempsurveydetail';
export * from './Teodsurveyquest';
export * from './Teodsurveyquestopt';
export * from './Teomcompany';
export * from './Teomemppersonal';
export * from './Teomposition';
export * from './Teomsurveyheader';
export * from './Ttadattendance';
export * from './Ttadattstatusdetail';
export * from './Ttadempgetleave';
export * from './Ttadleaverequest';
export * from './Ttadleaverequestdetail';
export * from './Ttadovtrequest';
export * from './Ttadovtrequestdetail';
export * from './Ttamleavetype';
export * from './Ttamshiftdaily';
export * from './Viewemployee';
export * from './ViewGoEmp';
export * from './ViewSearchEmp';
export * from './Accessmanagement';
export * from './ViewAttReport';
export * from './Ttadattcorrection';
export * from './SFAttCorrectionRequest';
export * from './ViewLeaveReport';
export * from './ViewOvertimeReport';
export * from './ViewShiftscheduleReport';
export * from './ViewCareerReport';
export * from './ViewEmpReq';
export * from './ViewLeaveBalanceReport';
export * from './ViewHeadcountGender';
export * from './ViewHeadcountMarital';
export * from './ViewHeadcountPos';
export * from './SFGenerateLeaveBalance';
export * from './Tsaimembersetting';
export * from './SFAttendanceStatus';
export * from './Ttamondutyallowitem';
export * from './Trmmreimtype';
export * from './Ttamondutypurposetype';
export * from './Ttadondutyrequest';
export * from './Ttadondutyrequestdtl';
export * from './TtadondutyrequestdtlAtd';
export * from './TtadondutyrequestdtlItem';
export * from './Ttarondutypurposecomp';
export * from './SFOnDuty';
export * from './ViewOndutyPurposeItem';
export * from './Ttamoddestination';
export * from './SFClaimRequest';
export * from './SFBusinesstripSetting';
export * from './SfBusinesstripdeclaration';
export * from './Ttadondutydeclaration';
export * from './Ttadondutydeclarationdtl';
export * from './SFLeaveRequestSF6';
export * from './SFRequestInbox';
export * from './SFOvertimeRequestSF6';
export * from './Tspostservice';
export * from './Tschatservice';
export * from './Tsfeedservice';
export * from './Tscalendarservice';
export * from './Tsmarketplace';
export * from './Tschatrealtime';
export * from './Sfrequestfor';
export * from './SFAttUploadSF6';
export * from './Ttadattendancetemp';
export * from './Sfbusinesstripdeclarationsf6';
export * from './SFAttCorrectionRequestSf6';
export * from './SFAttendanceSF6';
export * from './SFPolicy';
export * from './SFShiftScheduleSF6';
export * from './SFAnnouncement';
export * from './Securestorage';
export * from './ERPsalesCustomer';
export * from './SFShiftSchedule';
export * from './SFSearch';
export * from './SFAttendanceList';
export * from './Workflow';
export * from './SFShiftDaily';
export * from './SfRequest';
export * from './SfPayslip';
export * from './SFClaimReport';
export * from './SfPayrollWizard';
export * from './SFBankTransferReport';
export * from './SFBPJSKSReport';
export * from './SFPayProcess';
export * from './SFBPJSTKReport';
export * from './SFPayPeriod';
export * from './SFBpjsTkSummaryReport';
export * from './SFEmployeePayrollData';
export * from './Sfspt1721i';
export * from './SFSptMasa';
export * from './StoragePayroll';
export * from './SFPayroll';
export * from './SFPayProcessReport';
export * from './SFUploadPayComponent';
export * from './SfCareer';
export * from './SFChangeSpv';
export * from './SFAttSummary';
export * from './Ttamattstatus';
export * from './SFShiftDailySF6';
export * from './SFProfile';
export * from './SFCompany';
export * from './SFChangePrivacy';
export * from './RegistrationNew';
export * from './SFUploadPayHistory';
export * from './BuilderService';
export * from './InvitationMember';
export * from './SFEBanking';
export * from './ERPfinance';
export * from './ERPpurchase';
export * from './ERPinventory';
export * from './StorageInvitation';
export * from './MarketplaceAccess';
export * from './SFSpt1721A1';
export * from './TaskFeedbackService';
export * from './SFBusinesstripReport';
export * from './SFOnDutySF6';
export * from './SFOvtCancelRequestSF6';
export * from './SFOvtCancelRequest';
export * from './SFLeaveCancelRequest';
export * from './SFLeaveCancelRequestSF6';
export * from './ERPaccounting';
export * from './ERPreport';
export * from './ERPdataAuth';
export * from './ERPsalesContract';
export * from './ERPutil';
export * from './ERPsalesOrder';
export * from './PostService';
export * from './CalendarService';
export * from './FeedService';
export * from './ERPproduction';
export * from './ERPfixedAsset';
export * from './SFElearningSF6';
export * from './SFElearningReport';
export * from './SettingService';
export * from './ERPproformaInvoice';
export * from './ERPsalesBadDebt';
export * from './ERPsalesPlaning';
export * from './ERPsalesPrepaymentInvoice';
export * from './ERPsalesReturn';
export * from './ERPshippingInstruction';
export * from './ERPsalesPrepaymentSettlement';
export * from './ERPsalesDCNote';
export * from './ERPproject';
export * from './SfgisService';
export * from './SFPolling';
export * from './SFSmartfeed';
export * from './ERPpurchasePrepaymentInvoice';
export * from './ERPpurchaseContract';
export * from './ERPpurchaseDCNote';
export * from './ERPpurchasePrepaymentSettlement';
export * from './ERPpurchaseReturn';
export * from './ERPpurchaseCostingSheet';
export * from './ERPpurchaseReturnRequisition';
export * from './ERPinternalInventoryRequisition';
export * from './ERPinternalInventoryRequisitionReturn';
export * from './ERPinventoryAdjustmentValue';
export * from './ERPinventoryAdjustment';
export * from './ERPitemConversion';
export * from './ERPtransferOrder';
export * from './ERPpurchaseRequest';
export * from './SFAttValidation';
export * from './LeaderBoard';
export * from './Activity';
export * from './StorageActivity';
export * from './ActivityImages';
export * from './ActivityService';
export * from './ERPpurchaseRequest';
export * from './CostCenterService';
export * from './Department';
export * from './Position';
export * from './StandardizedService';
export * from './WorkLocation';
export * from './SFAttValidation';
export * from './AttendanceMachine';
export * from './StorageLeave';
export * from './LeaveSetup';
export * from './StorageAttendanceMachine';
export * from './LeaderBoard';
export * from './SFAppraisal';
export * from './StorageAttachmentFile';
export * from './BaseModels';
export * from './WinnerHistory';
export * from './StoragePartner';
export * from './FireLoopRef';
export * from './SFClaimCancelRequest';
export * from './QueueService';
export * from './JobGradeServices';
export * from './Ssobranchservice';
export * from './LeaveReportService';
export * from './ImplementationService';
export * from './TeomworklocationService';
export * from './TtamattlocationService';
export * from './TtademplocationService';
export * from './ViewActivityReport';
export * from './EmployeeDataUpdate';
export * from './PaymentService';
export * from './PayrollHistoryService';
export * from './Contact';
export * from './SunfishAuthenticatorService';
export * from './AttendanceReport';
export * from './PaydayLoanService';
export * from './ListSpvPath';
export * from './EmployeeRequest';
export * from './SurveyService';
export * from './Yesdokservice';




// WEBPACK FOOTER //
// ./src/shared/sdk/models/index.ts